import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';

export default class BankAccount extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            caller: props.Caller,
            data: null,
            loading: true,
            tab: 1,
            pos: null,
            cheque: null,
            removedPos: [],
            removedCheque: [],
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        this.httpPost("api/v1/bankaccount/get", {
            id: this.state.id,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.state.pos = this.getBlankPos();
                    this.state.cheque = this.getBlankCheque();
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();

        if (this.isBlank(this.state.data.record.firstAnnualRemain)) this.state.data.record.firstAnnualRemain = 0;

        this.httpPost("api/v1/bankaccount/save", {
            id: this.state.id,
            organizationId: this.state.data.global.company.id,
            name: this.state.data.record.name,
            code: this.state.data.record.code,
            number: this.state.data.record.number,
            bankName: this.state.data.record.bankName,
            sheba: this.state.data.record.sheba,
            branch: this.state.data.record.branch,
            groupId: this.state.data.record.groupId,
            firstAnnualRemain: parseInt(this.state.data.record.firstAnnualRemain),
            removedCheque: this.state.removedCheque,
            removedPos: this.state.removedPos,
            poses: this.state.data.poses,
            cheques: this.state.data.cheques,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    getBlankPos() {
        return {
            id: this.uuidv4(),
            isNewItem: true,
            name: '',
            serial: ''
        };
    }
    getBlankCheque() {
        return {
            id: this.uuidv4(),
            isNewItem: true,
            numberFrom: 0,
            numberTo: 0,
            serial: 0
        };
    }
    addPos() {
        if (this.isBlank(this.state.pos.name)) {
            this.showErorrMessage("لطفا نام دستگاه را وارد نمایید");
            return;
        }
        if (this.isBlank(this.state.pos.serial)) {
            this.showErorrMessage("لطفا سریال دستگاه را وارد نمایید");
            return;
        }
        this.state.data.poses.push(this.state.pos);
        this.setState({ pos: this.getBlankPos() });
    }
    addCheque() {
        if (this.isBlank(this.state.cheque.serial) || this.state.cheque.serial == 0) {
            this.showErorrMessage("لطفا سریال دسته چک را وارد نمایید");
            return;
        }
        if (this.isBlank(this.state.cheque.numberFrom) || this.state.cheque.numberFrom == 0) {
            this.showErorrMessage("لطفا شماره شروع دسته چک را وارد نمایید");
            return;
        }
        if (this.isBlank(this.state.cheque.numberTo) || this.state.cheque.numberTo == 0) {
            this.showErorrMessage("لطفا شماره اتمام دسته چک را وارد نمایید");
            return;
        }
        if (this.state.cheque.numberTo < this.state.cheque.numberFrom) {
            this.showErorrMessage("شماره اتمام بایستی بزرگتر از شماره شروع باشد");
            return;
        }
        this.state.data.cheques.push(this.state.cheque);
        this.setState({ cheque: this.getBlankCheque() });
    }
    removePos(id) {
        var t = [];
        this.state.data.poses.forEach(f => {
            if (f.id != id) {
                if (f.isNewItem == true) this.state.removedPos.push(f.id);
                t.push(f);
            }
        });
        this.setState({ removedPos: this.state.removedPos });
    }
    removeCheque(id) {
        var t = [];
        this.state.data.cheques.forEach(f => {
            if (f.id != id) {
                if (f.isNewItem == true) this.state.removedCheque.push(f.id);
                t.push(f);
            }
        });
        this.setState({ removedCheque: this.state.removedPos });
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable">
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close hand" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">
                                {this.state.data.record.id != this.defaultGuid() ? "ویرایش اطلاعات حساب بانکی" : "افزودن حساب بانکی جدید"}
                            </h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-8">
                                        <div className="form-group">
                                            <label for="bank-name" className="title1">عنوان حساب </label><span className="red">*</span>
                                            <input defaultValue={this.state.data.record.name} onChange={e => this.state.data.record.name = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="branch" className="title1">نام بانک</label><span className="red">*</span>
                                            <input defaultValue={this.state.data.record.bankName} onChange={e => this.state.data.record.bankName = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                        </div>
                                    </div>
                                    {/*<div className="col-sm-4">*/}
                                    {/*    <div className="form-group">*/}
                                    {/*        <label for="branch" className="title1">موجودی اول دوره</label><span className="red">*</span>*/}
                                    {/*        <input defaultValue={this.state.data.record.firstAnnualRemain} onChange={e => this.state.data.record.firstAnnualRemain = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />*/}
                                    {/*    </div>*/}
                                    {/*</div> */}
                                </div>
                                <div className="row">
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="accountnumber" className="title1">شماره حساب</label><span className="red">*</span>
                                            <input defaultValue={this.state.data.record.number} onChange={e => this.state.data.record.number = e.target.value} autocomplete="off" type="text" className="form-control input-smnumber" maxlength="40" />
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="accountnumber" className="title1">شماره شبا</label><span className="red">*</span>
                                            <input defaultValue={this.state.data.record.sheba} onChange={e => this.state.data.record.sheba = e.target.value} autocomplete="off" type="text" className="form-control input-smnumber" maxlength="40" />
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="branch" className="title1">شعبه</label>
                                            <input defaultValue={this.state.data.record.branch} onChange={e => this.state.data.record.branch = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <ul className="nav nav-tabs">
                                        <li className={this.state.tab === 1 ? "active" : ""}><a onClick={e => this.setState({tab: 1})} className="hand">دستگاه های پوز</a></li>
                                        <li className={this.state.tab === 2 ? "active" : ""}><a onClick={e => this.setState({ tab: 2 })} className="hand">چکها</a></li>
                                    </ul>
                                    <div className="tab-content">
                                        {this.state.tab === 1 && <div className="tab-pane fade active in">
                                            <div className="row" key={this.state.pos.id }>
                                                <div className="col-sm-5">
                                                    <div className="form-group">
                                                        <label for="name" className="title1">عنوان دستگاه</label>
                                                        <input defaultValue={this.state.pos.name} onChange={e => this.state.pos.name = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                                    </div>
                                                </div>

                                                <div className="col-sm-4">
                                                    <div className="form-group">
                                                        <label for="name" className="title1">شماره سریال</label>
                                                        <input defaultValue={this.state.pos.serial} onChange={e => this.state.pos.serial = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="12" />
                                                    </div>
                                                </div>

                                                <div className="col-sm-3">
                                                    <div className="form-group">
                                                        <a className="btn btn-default hand" onClick={e => this.addPos()} style={{ "margin-top": "29px" }} > <i className="fa fa-plus"> افزودن </i></a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12" style={{ "max-height": "250px", "overflow-y": "scroll", "padding-left": "0" }}>
                                                    <table className="table table-bordered" style={{ "margin": "0" }} >
                                                        <thead>
                                                            <tr className="active" style={{ "font-size": "9pt", "font-weight": "bold" }}>
                                                                <td>عنوان</td>
                                                                <td>سریال دستگاه</td>
                                                                <td></td>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {this.state.data.poses.map(p => <tr style={{ "height": "37px!important" }} >
                                                                <td style={{ "min-width": "220px" }} className="invoice-td">{p.name}</td>
                                                                <td style={{ "min-width": "220px" }} className="invoice-td">{p.serial}</td>
                                                                <td style={{ "width": "120px" }} className="invoice-td">
                                                                    <a className="hand" onClick={ e=>this.removePos(p.id) }>حذف</a>
                                                                </td>
                                                            </tr>)}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>}
                                        {this.state.tab === 2 && <div className="tab-pane fade active in">
                                            <div className="row" key={this.state.cheque.id}>
                                                <div className="col-sm-3">
                                                    <div className="form-group">
                                                        <label for="name" className="title1">سریال چک</label>
                                                        <input defaultValue={this.state.cheque.serial} onChange={e => this.state.cheque.serial = parseInt(e.target.value)} autocomplete="off" type="text" className="form-control input-sm" maxlength="12" />
                                                    </div>
                                                </div>
                                                <div className="col-sm-3">
                                                    <div className="form-group">
                                                        <label for="name" className="title1">از شماره</label>
                                                        <input defaultValue={this.state.cheque.numberFrom} onChange={e => this.state.cheque.numberFrom = parseInt(e.target.value)} autocomplete="off" type="text" className="form-control input-sm" maxlength="12" />
                                                    </div>
                                                </div>
                                                <div className="col-sm-3">
                                                    <div className="form-group">
                                                        <label for="name" className="title1">تا شماره</label>
                                                        <input defaultValue={this.state.cheque.numberTo} onChange={e => this.state.cheque.numberTo = parseInt(e.target.value)} autocomplete="off" type="text" className="form-control input-sm" maxlength="12" />
                                                    </div>
                                                </div>
                                                <div className="col-sm-3">
                                                    <div className="form-group">
                                                        <a className="btn btn-default hand" onClick={e => this.addCheque()} style={{ "margin-top": "29px" }} ><i className="fa fa-plus"> افزودن </i></a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12" style={{ "max-height": "250px", "overflow-y": "scroll", "padding-left": "0" }}>

                                                    <table className="table table-bordered" style={{ "margin": "0" }} >
                                                        <thead>
                                                            <tr className="active" style={{ "font-size": "9pt", "font-weight": "bold" }} >
                                                                <td>سریال چک</td>
                                                                <td>از شماره</td>
                                                                <td>تا شماره</td>
                                                                <td></td>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {this.state.data.cheques.map(p => <tr style={{ "height": "37px!important" }} >
                                                                <td style={{ "min-width": "220px" }} className="invoice-td">{p.serial}</td>
                                                                <td style={{ "min-width": "110px" }} className="invoice-td">{p.numberFrom}</td>
                                                                <td style={{ "min-width": "110px" }} className="invoice-td">{p.numberTo}</td>
                                                                <td style={{ "width": "120px" }} className="invoice-td">
                                                                    <a className="hand" onClick={e => this.removeCheque(p.id)}>حذف</a>
                                                                </td>
                                                            </tr>)}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-default btn-smoke hand" onClick={e => this.closeMe()}>انصراف </button>
                            <button type="submit" name="bank_form_modal_submit" className="btn btn-success" onClick={e => this.save(e)}>
                                ذخیره
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        </div >
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm()
            ];

        return contents;
    }
}